var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { GET_BOARDS } from '.';
var Containter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  padding: 20px;\n  background: #f0f0f0;\n  overflow: hidden;\n\n  > .header {\n    width: 100%;\n    height: 50px;\n\n    > ul {\n      width: 100%;\n\n      > .title {\n        float: left;\n        font-size: 18px;\n        font-weight: 800;\n      }\n\n      > .new-category {\n        float: right;\n        margin-left: 30px;\n        \n        > form {\n          > label {\n            font-size: 16px;\n          }\n  \n          > input {\n            width: 150px;\n            height: 30px;\n            margin-left: 10px;\n            font-size: 14px;\n            padding: 5px;\n          }\n  \n          > button {\n            cursor: pointer;\n            box-sizing: border-box;\n            margin-left: 5px;\n            width: 100px;\n            height: 30px;\n            text-align: center;\n            background: #36c;\n            border: 0;\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n\n  > .category-list {\n    width: 100%;\n    clear: both;\n\n    > span {\n      padding: 10px;\n      border-radius: 10px;\n      background: #247B7B;\n      color: #fff;\n      font-size: 14px;\n\n      &:not(:first-child) {\n        margin-left: 20px;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  padding: 20px;\n  background: #f0f0f0;\n  overflow: hidden;\n\n  > .header {\n    width: 100%;\n    height: 50px;\n\n    > ul {\n      width: 100%;\n\n      > .title {\n        float: left;\n        font-size: 18px;\n        font-weight: 800;\n      }\n\n      > .new-category {\n        float: right;\n        margin-left: 30px;\n        \n        > form {\n          > label {\n            font-size: 16px;\n          }\n  \n          > input {\n            width: 150px;\n            height: 30px;\n            margin-left: 10px;\n            font-size: 14px;\n            padding: 5px;\n          }\n  \n          > button {\n            cursor: pointer;\n            box-sizing: border-box;\n            margin-left: 5px;\n            width: 100px;\n            height: 30px;\n            text-align: center;\n            background: #36c;\n            border: 0;\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n\n  > .category-list {\n    width: 100%;\n    clear: both;\n\n    > span {\n      padding: 10px;\n      border-radius: 10px;\n      background: #247B7B;\n      color: #fff;\n      font-size: 14px;\n\n      &:not(:first-child) {\n        margin-left: 20px;\n      }\n    }\n  }\n"])));
var ADD_CATEGORY = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation AddCategory($board: AddingCategoryInput!) {\n    addCategory(board: $board)\n  }\n"], ["\n  mutation AddCategory($board: AddingCategoryInput!) {\n    addCategory(board: $board)\n  }\n"])));
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            categoryName: ''
        };
        _this.handleChange = function (e) {
            e.preventDefault();
            _this.setState({
                categoryName: e.target.value,
            });
        };
        _this.handleSubmit = function (addCategory, e) { return __awaiter(_this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        id = this.props.id;
                        return [4 /*yield*/, addCategory({
                                variables: {
                                    board: {
                                        id: id,
                                        category: this.state.categoryName,
                                    }
                                }
                            })];
                    case 1:
                        _a.sent();
                        this.setState({
                            categoryName: '',
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Category.prototype.render = function () {
        var _this = this;
        var _a = this.props, categories = _a.categories, projectName = _a.projectName, pageName = _a.pageName;
        return (React.createElement(Mutation, { mutation: ADD_CATEGORY, refetchQueries: [{
                    query: GET_BOARDS,
                    variables: { projectName: projectName, pageName: pageName },
                }] }, function (addCategory) { return (React.createElement(Containter, null,
            React.createElement("div", { className: "header" },
                React.createElement("ul", null,
                    React.createElement("li", { className: "title" }, "\uCE74\uD14C\uACE0\uB9AC"),
                    React.createElement("li", { className: "new-category" },
                        React.createElement("form", { onSubmit: function (e) { return _this.handleSubmit(addCategory, e); } },
                            React.createElement("label", { htmlFor: "category" }, "\uC0C8 \uCE74\uD14C\uACE0\uB9AC \uCD94\uAC00"),
                            React.createElement("input", { name: "category", value: _this.state.categoryName, onChange: _this.handleChange }),
                            React.createElement("button", { type: "submit" }, "\uCD94\uAC00"))))),
            categories.length > 1 && (React.createElement("div", { className: "category-list" }, categories.map(function (category, idx) {
                if (idx === 0)
                    return null;
                return React.createElement("span", { key: idx }, category);
            }))))); }));
    };
    return Category;
}(React.Component));
export default Category;
var templateObject_1, templateObject_2;
